<template>
  <Transition name="fab">
    <button
      v-show="visible"
      type="button"
      class="scroll-top"
      aria-label="Scroll to top"
      @click="scrollToTop"
    >
      <v-icon size="20">mdi-arrow-up</v-icon>
    </button>
  </Transition>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const visible = ref(false);

const onScroll = () => {
  visible.value = window.scrollY > 400;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

onMounted(() => window.addEventListener("scroll", onScroll, { passive: true }));
onBeforeUnmount(() => window.removeEventListener("scroll", onScroll));
</script>

<style scoped>
.scroll-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 150;
  width: 48px;
  height: 48px;
  border-radius: var(--radius-full);
  background: var(--color-accent);
  border: none;
  color: var(--color-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px var(--color-accent-glow);
  transition: transform var(--transition), box-shadow var(--transition);
}

.scroll-top:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 28px var(--color-accent-glow);
}

.fab-enter-active,
.fab-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fab-enter-from,
.fab-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
